import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`crea-prodotto`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
